import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import RaisedButton from 'material-ui/RaisedButton';
import AutoComplete from 'material-ui/AutoComplete';

import styles from 'styles';
import { updateRequestCargo, deleteRequestCargo } from 'actions/cargoes/requests';
import api from 'services';
import OpenMailBlock from 'components/Base/Mails/OpenMailBlock';
import { execute } from 'store/configureStore';
import { saveRequestsDataDeleted } from 'sagas/orders';

class Item extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userEmails: [],
            name: this.props.item.addedBy.name || '',
            surname: this.props.item.addedBy.surname || '',
            email: this.props.item.addedBy.email || '',
            cargoRequestId: this.props.item._id,
            id: this.props.item.addedBy._id,
            isUpdate: false,
        };

        this.changeUser = this.changeUser.bind(this);
        this.chooseUser = this.chooseUser.bind(this);
        this.deleteCargoRequest = this.deleteCargoRequest.bind(this);
        this.updateCargoRequest = this.updateCargoRequest.bind(this);
        this.saveRequestsDataDeleted = this.saveRequestsDataDeleted.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            isUpdate: nextProps.item.isUpdate,
            item: nextProps.item,
        });
    }

    saveRequestsDataDeleted = async () => {
        try {
            await execute(saveRequestsDataDeleted, 'cargo', { mailId: this.props.item.mailId });
        } catch (error) {
            console.error(error);
        }
    };

    deleteCargoRequest() {
        this.props.item.mailId && this.saveRequestsDataDeleted();
        this.props.deleteRequestCargo(this.state.cargoRequestId);
    }

    updateCargoRequest() {
        this.props.updateRequestCargo(this.state.cargoRequestId, this.state.id);
    }

    changeUser(searchText) {
        this.setState({
            email: searchText,
            isUpdate: false,
        }, () => {
            api.findUser(searchText)
                .then((response) => {
                    const userEmails = response.data.data.map(user => ({
                        name: `${user.email} - (${user.name || ''} ${user.surname || ''})`,
                        item: user,
                    }));

                    this.setState({
                        userEmails,

                    });
                })
                .catch(() => null);
        });

    }

    chooseUser(updateProperties) {
        if (!updateProperties) {
            return;
        }

        this.setState({
            name: updateProperties.item.name,
            surname: updateProperties.item.surname,
            email: updateProperties.item.email,
            id: updateProperties.item._id,
            isUpdate: true,
        });
    }

    render() {
        const { email, userEmails, isUpdate, name, surname } = this.state;
        const { item } = this.props;

        let autoComplete = (<AutoComplete
            textFieldStyle={styles.autoCompleteCSS}
            hintText='User'
            searchText={email}
            dataSource={userEmails}
            dataSourceConfig={{ text: 'name', value: 'item' }}
            onUpdateInput={this.changeUser}
            onNewRequest={this.chooseUser}
            filter={AutoComplete.noFilter}
            fullWidth
            listStyle={styles.autoCompleteListStyle}
            popoverProps={{
                canAutoPosition: true,
                anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                targetOrigin: { horizontal: 'left', vertical: 'top' },
            }}
        />);

        let managementBlock = (<div className='paper-block'>
            <div className='name-block absolute small-name'>Managment</div>
            <RaisedButton
                onClick={this.deleteCargoRequest}
                label='Delete'
                style={{ margin: '0 10px 0 0' }}
                secondary
            />
            <RaisedButton
                onClick={this.updateCargoRequest}
                disabled={!isUpdate}
                label='Update user'
                style={{ margin: '0 10px 0 0' }}
                primary
            />
        </div>);

        if (item.fixed) {
            managementBlock = (<div className='paper-block'>
                <div className='name-block absolute small-name'>Fixed</div>
                <span>FIXED: </span><br />
            </div>);

            autoComplete = (<div><span>Email: </span>{email}</div>);
        }

        if (this.props.item.deleteBy) {
            managementBlock = (<div className='paper-block'>
                <div className='name-block absolute small-name'>Deleted</div>
                <span>Delete at: </span>{moment(item.deleteAt).format('MM-DD-YYYY')}<br />
                <span>Delete by: </span>{item.deleteBy.email}
            </div>);
            autoComplete = (<div><span>Email: </span>{this.state.email}</div>);
        }

        return (
            <div className='paper-block item-request'>
                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>unique info</div>
                        <span>refNo: </span>{item.refNo}
                    </div>

                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>requests</div>
                        <span>Freight Requests count: </span>{item.freightRequests}<br />
                        <span>Offers Requests count: </span>{item.offersRequests}<br />
                        <span>Recommended count: </span>{item.recommended}<br />
                    </div>

                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>POL</div>
                        <span>Loading port: </span>{item.loadingPort ? item.loadingPort.name : ''}<br />
                        <span>Cancelling Date: </span>{moment(item.cancellingDate).startOf('day').toDate().toLocaleDateString()}<br />
                        <span>Readiness Date: </span>{moment(item.readinessDate).startOf('day').toDate().toLocaleDateString()}<br />
                    </div>

                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>POD</div>
                        <span>Unloading Port: </span>{item.unloadingPort ? item.unloadingPort.name : ''}<br />
                    </div>
                </div>

                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>cargo</div>
                        <span>Cargo: </span>{item.cargo[0]}
                    </div>

                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>Total Values</div>
                        <span>Volume: </span>{item.totalValues.volume}<br />
                        <span>Volume With Percent: </span>{item.totalValues.volumeWithPercent}<br />
                        <span>Weight: </span>{item.totalValues.weight}<br />
                        <span>Weight With Percent: </span>{item.totalValues.weightWithPercent}<br />
                    </div>

                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>Company</div>
                        <span>Name: </span>{item.addedBy.company ? item.addedBy.company.name : ''}
                    </div>
                </div>

                <div className='col col-4'>
                    <div className='paper-block'>
                        <div className='name-block absolute small-name'>User</div>
                        <span>Name: </span>{name}<br />
                        <span>Surname: </span>{surname}<br />
                        {autoComplete}
                    </div>
                    {
                        item.realUser && (
                            <div className='paper-block'>
                                <div className='name-block absolute small-name'>Real user</div>
                                <span>Email: </span>{item.realUser.email}<br />
                            </div>
                        )
                    }
                    {managementBlock}
                    {
                        item.mailId && <OpenMailBlock mailId={item.mailId} />
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            item: ownProps.item,
        };
    },
    dispatch => bindActionCreators({
        updateRequestCargo,
        deleteRequestCargo,
    }, dispatch),
)(Item);



// WEBPACK FOOTER //
// ./app/components/Cargoes/Requests/Item.jsx